import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { categorySubMenus, toolsSubMenus } from '../../publicCatalogDropdownConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { sortOptions, getSerializedOptions } from '../../publicCatalogDropdownHooks';
import MenuOption from './MenuOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuHeading = ({
  children,
  props
}) => /*#__PURE__*/_jsx(View, Object.assign({
  backgroundColor: "fill-field-default",
  borderBlockEndColor: "border-core-subtle",
  borderBlockEndStyle: "solid",
  borderBlockEndWidth: "100"
}, props, {
  children: /*#__PURE__*/_jsx(Paragraph, {
    margin: "0",
    typography: "body-125",
    children: children
  })
}));
const TopLevelMenuContent = ({
  filtersData
}) => {
  const {
    topLevelOptionsPresent: categoryTopLevelOptionsPresent
  } = getSerializedOptions('cat', filtersData.subCategories);
  const {
    topLevelOptionsPresent: toolsTopLevelOptionsPresent
  } = getSerializedOptions('tools', filtersData.hsSoftwareFilters);
  return /*#__PURE__*/_jsxs(List, {
    wrapChildren: true,
    children: [/*#__PURE__*/_jsx(MenuHeading, {
      props: {
        paddingBlock: '200',
        paddingInline: '500'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.cat.filterTitle"
      })
    }), categorySubMenus.map(subMenuName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "cat",
      isSubMenu: true,
      optionName: subMenuName
    }, subMenuName)), sortOptions(Array.from(categoryTopLevelOptionsPresent)).map(optionName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "cat",
      optionName: optionName
    }, optionName)), /*#__PURE__*/_jsx(MenuHeading, {
      props: {
        paddingBlock: '200',
        paddingInline: '500'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.tools.filterTitle"
      })
    }), toolsSubMenus.map(subMenuName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "tools",
      isSubMenu: true,
      optionName: subMenuName
    }, subMenuName)), sortOptions(Array.from(toolsTopLevelOptionsPresent)).map(optionName => /*#__PURE__*/_jsx(MenuOption, {
      filterName: "tools",
      optionName: optionName
    }, optionName))]
  });
};
export default TopLevelMenuContent;